/* BODIED free shipping progress bar: free shipping is automatic for any subscription (Shopify discount
   "Free Shipping on Subscriptions"), so show the Kaching Cart bar as unlocked whenever a subscription is in the cart. */
(() => {
  const BAR = '#kaching-cart .kaching-cart__tiered-promotions-bar';
  let t;
  let busy = false;

  const unlock = (b) => {
    const p = b.querySelector('.kaching-cart__tiered-promotions-bar-text');
    const f = b.querySelector('.kaching-cart__tiered-promotions-bar-progress-fill');
    if (!p || !f) return;
    if (!/unlocked/i.test(p.textContent)) p.innerHTML = "You've unlocked <strong>Free shipping</strong>!";
    if (f.style.width !== '100%') f.style.width = '100%';
    b.setAttribute('data-fsb', '1');
  };

  async function check() {
    const bars = [...document.querySelectorAll(BAR)].filter((b) => !b.hasAttribute('data-fsb') || !/unlocked/i.test(b.textContent));
    if (!bars.length || busy) return;
    busy = true;
    try {
      const cart = await (await fetch('/cart.js')).json();
      if (cart.items.some((l) => l.selling_plan_allocation)) document.querySelectorAll(BAR).forEach(unlock);
    } catch (e) {
    } finally {
      busy = false;
    }
  }

  // Kaching re-renders the bar on every cart change, so re-check when it appears
  new MutationObserver((m) => {
    if (!m.some((x) => [...x.addedNodes].some((n) => n.nodeType === 1))) return;
    clearTimeout(t);
    t = setTimeout(check, 80);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();